import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface MenuItem {
  id: string;
  label: string;
  href?: string;
  icon?: string;
  subtext?: string;
  isActive?: boolean;
  onClick?: () => void;
  children?: MenuItem[];
}

interface MenuContextType {
  currentMenuComponent: React.ComponentType | null;
  setMenuComponent: (component: React.ComponentType | null) => void;
  resetToMainMenu: () => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenu must be used within a MenuProvider');
  }
  return context;
};

interface MenuProviderProps {
  children: ReactNode;
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
  const [currentMenuComponent, setCurrentMenuComponent] = useState<React.ComponentType | null>(null);

  const setMenuComponent = (component: React.ComponentType | null) => {
    setCurrentMenuComponent(()=> component);
  };

  const resetToMainMenu = () => {
    setCurrentMenuComponent(null);
  };

  const value = {
    currentMenuComponent: currentMenuComponent,
    setMenuComponent,
    resetToMainMenu,
  };

  return (
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
};
